const places = {
  'Alphen-Chaam': { lat: 51.499710083843496, lng: 4.880940988812415 },
  'Altena': { lat: 51.767751070245986, lng: 4.942746605567925 },
  'Asten': { lat: 51.40220207989611, lng: 5.7858490780475895 },
  'Baarle-Nassau': { lat: 51.44442975299727, lng: 4.930128333453853 },
  'Bergeijk': { lat: 51.313553917667726, lng: 5.333387480068765 },
  'Bergen op Zoom': { lat: 51.49176250538894, lng: 4.311504291266407 },
  'Bernheze': { lat: 51.68589909742157, lng: 5.523576834435356 },
  'Best': { lat: 51.512117970465624, lng: 5.398306968525718 },
  'Bladel': { lat: 51.34937788529902, lng: 5.215426584575874 },
  'Boekel': { lat: 51.60382036278431, lng: 5.676156782336299 },
  'Boxtel': { lat: 51.58344395683545, lng: 5.300963121556256 },
  'Breda': { lat: 51.58786091050574, lng: 4.770863480149543 },
  'Cranendonck': { lat: 51.30404701632194, lng: 5.5867349078432635 },
  'Deurne': { lat: 51.463737367082246, lng: 5.801933010354071 },
  'Dongen': { lat: 51.629985365686906, lng: 4.942728789395537 },
  'Drimmelen': { lat: 51.68455216411639, lng: 4.740681576890159 },
  'Eersel': { lat: 51.40115289555047, lng: 5.32145331335654 },
  'Eindhoven': { lat: 51.4430238766469, lng: 5.470564533621547 },
  'Etten-Leur': { lat: 51.575219590974946, lng: 4.647492609225654 },
  'Geertruidenberg': { lat: 51.70171765711329, lng: 4.850266957764466 },
  'Geldrop-Mierlo': { lat: 51.43362441502179, lng: 5.591511294594875 },
  'Gemert-Bakel': { lat: 51.546983275094725, lng: 5.749020528631389, },
  'Gilze en Rijen': { lat: 51.56510866600888, lng: 4.921582259090971 },
  'Goirle': { lat: 51.508905599611374, lng: 5.04434298752236 },
  'Halderberge': { lat: 51.59346560193589, lng: 4.534722065918501 },
  'Heeze-Leende': { lat: 51.38461793066831, lng: 5.577237154162793 },
  'Helmond': { lat: 51.481635672603666, lng: 5.65114073516317 },
  "'s-Hertogenbosch": { lat: 51.71207818309595, lng: 5.322628824361529 },
  'Heusden': { lat: 51.73249334281718, lng: 5.143032284472697 },
  'Hilvarenbeek': { lat: 51.49984125596194, lng: 5.114496943658533 },
  'Laarbeek': { lat: 51.52916701158548, lng: 5.614802224375759 },
  'Land van Cuijk': { lat: 51.73007379469125, lng: 5.876413398518948 },
  'Loon op Zand': { lat: 51.632297870547326, lng: 5.07609920322634 },
  'Maashorst': { lat: 51.63917762367489, lng: 5.644033423056432 },
  'Meierijstad': { lat: 51.5898889755219, lng: 5.511891697077251 },
  'Moerdijk': { lat: 51.652288596420924, lng: 4.531219617845157 },
  'Nuenen': { lat: 51.47074298395585, lng: 5.546670319029062 },
  'Oirschot': { lat: 51.50862224958395, lng: 5.314144513152235 },
  'Oisterwijk': { lat: 51.57128847912418, lng: 5.209470958485954 },
  'Oosterhout': { lat: 51.64645762650666, lng: 4.854902852320479 },
  'Oss': { lat: 51.7617048578693, lng: 5.52176582008664 },
  'Reusel-De Mierden': { lat: 51.37715308836846, lng: 5.142383032009025 },
  'Roosendaal': { lat: 51.529979588658684, lng: 4.458657251115565 },
  'Rucphen': { lat: 51.53188462308528, lng: 4.552232257626313 },
  'Sint-Michielsgestel': { lat: 51.64372117654015, lng: 5.348768607546004 },
  'Someren': { lat: 51.3731127195545, lng: 5.700402248205234 },
  'Son en Breugel': { lat: 51.51416853739829, lng: 5.478885383548362 },
  'Steenbergen': { lat: 51.57981561775955, lng: 4.318626721082792 },
  'Tilburg': { lat: 51.57395067996607, lng: 5.06804316644984 },
  'Valkenswaard': { lat: 51.31984812717155, lng: 5.453518272584383 },
  'Veldhoven': { lat: 51.41960012041626, lng: 5.406695477711675 },
  'Vught': { lat: 51.65268061405649, lng: 5.2922263817559205 },
  'Waalre': { lat: 51.38697564598433, lng: 5.465497027408085 },
  'Waalwijk': { lat: 51.68746654221709, lng: 5.062358252543342 },
  'Woensdrecht': { lat: 51.41777581826893, lng: 4.286834754702098 },
  'Zundert': { lat: 51.47858367885052, lng: 4.6445885492311 },
}

export default places;